var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49725 18.7318C5.30685 18.7343 3.18787 17.9529 1.52343 16.5289C1.32974 16.3636 1.17417 16.1583 1.06743 15.9271C0.960705 15.6959 0.905351 15.4443 0.905187 15.1897C0.905187 12.8741 2.77914 11.021 5.0951 11.021H9.906C12.2225 11.021 14.0893 12.8741 14.0893 15.1897C14.0895 15.4442 14.0343 15.6958 13.9277 15.9269C13.821 16.1581 13.6654 16.3633 13.4716 16.5283C11.8073 17.9529 9.68797 18.7345 7.49725 18.7318Z",
    fill: "#E9F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.737646C8.59653 0.737573 9.64817 1.17311 10.4236 1.94846C11.199 2.7238 11.6347 3.77543 11.6347 4.87201C11.6348 5.96858 11.1993 7.02027 10.424 7.79572C9.64866 8.57116 8.59707 9.00685 7.50055 9.00692C6.40402 9.00699 5.35238 8.57145 4.57697 7.79611C3.80155 7.02076 3.36589 5.96913 3.36582 4.87256C3.36575 3.77598 3.80127 2.72429 4.57658 1.94885C5.35189 1.1734 6.40347 0.737719 7.5 0.737646Z",
    fill: "#E9F7FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.87e05500896e4838b53f5a5aaa71e590.svg";
export { ForwardRef as ReactComponent };